// extracted by mini-css-extract-plugin
module.exports = {"root":"ob_f4G74P","container":"ob_56Kluu","iconWithoutLabel":"ob_1xQHFM","iconWithoutLabel__dark":"ob_YZwqqt","item":"ob_gE4v7t","icon":"ob_BCt88f"};